import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-observation-summary',
    template: ` <div class="cmps-coaching-observation-summary--fc">
            <div class="cmps-coaching-observation-summary--other">
                <div class="cmps-coaching-observation-summary--info">
                    <span class="cmps-coaching-observation-summary--label"
                        >{{ notesLabel }}&nbsp;</span
                    >
                    <span>{{ notes }}</span>
                </div>
                <div class="cmps-coaching-observation-summary--info">
                    <span class="cmps-coaching-observation-summary--label"
                        >{{ interactionsLabel }}&nbsp;</span
                    >
                    <span>{{ interactions }}</span>
                </div>
            </div>
            <div class="cmps-coaching-observation-summary--other">
                <div class="cmps-coaching-observation-summary--info">
                    <span class="cmps-coaching-observation-summary--label"
                        >{{ dateLabel }}&nbsp;</span
                    >
                    <span>{{ date }}</span>
                </div>
            </div>
            <div class="cmps-coaching-observation-summary--actions">
                <button
                    cmpsIconButton
                    [cmpsTooltipTrigger]="actionTooltip"
                    [openDelay]="750"
                    (click)="action.emit($event)"
                >
                    <cmps-icon
                        [svgIcon]="
                            !published
                                ? '__internal:pencil'
                                : '__internal:text-box-outline'
                        "
                    ></cmps-icon>
                </button>
            </div>
        </div>
        <cmps-coaching-focus-item-summary
            [opportunityLabel]="opportunityLabel"
            [opportunity]="opportunity"
            [willingnessLabel]="willingnessLabel"
            [willingness]="willingness"
            [proficiencyLabel]="proficiencyLabel"
            [proficiency]="proficiency"
        ></cmps-coaching-focus-item-summary>`,
    host: {
        class: 'cmps-coaching-observation-summary',
        '[class.cmps-coaching-observation-summary--active]': 'active',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsObservationSummaryComponent implements OnDestroy {
    @Input() notesLabel: string;
    @Input() notes: string;
    @Input() interactionsLabel: string;
    @Input() interactions: string;
    @Input() dateLabel: string;
    @Input() date: string;
    @Input() published: boolean;
    @Input() active: boolean;
    @Input() actionTooltip: string | TemplateRef<any>;
    @Output() action: EventEmitter<MouseEvent | KeyboardEvent>;

    @Input() opportunityLabel: string;
    @Input() opportunity: string;
    @Input() willingnessLabel: string;
    @Input() willingness: string;
    @Input() proficiencyLabel: string;
    @Input() proficiency: string;

    constructor() {
        this.action = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.action.complete();
    }
}
